// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"27af000d","807":"d250055b","875":"3804bb82"}[chunkId] + ".chunk.js";
};